module.exports = __webpack_public_path__ + "static/media/RealtimeIcon.1b8e7e09.svg";